import React from 'react';
import { styled } from 'baseui';
import { useAtomValue } from 'jotai';
import { VerticalDivider } from '../../../../common/divider/divider';
import { TOOL } from '../../../labelling/constants';
import { annotationLabelsAtom } from '../../atoms/annotation-atoms';
import UndoRedo from './undo-redo/undo-redo-control';
import BrightnessControl from './brightness-control';
import ContrastControl from './contrast-control';
import { GridControl } from './grid-control';
import { PointerControl } from './pointer-control';
import RotateControl from './rotate-control';
import { SnapControl } from './snap-control';
import { ToolSelectorControl } from './tool-selector-control';
import { VideoGridView } from './video-grid-view';
import ZoomControl from './zoom-control';
const Container = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: $theme.colors.backgroundPrimary,
  paddingLeft: $theme.sizing.scale600,
  paddingRight: $theme.sizing.scale600
}));
function StageControlToolBar() {
  const annotationLabels = useAtomValue(annotationLabelsAtom);
  const hasSegmentationTool = annotationLabels.some(label => label.tools?.includes(TOOL.SEGMENTATION));
  return <Container>
      <PointerControl />
      <ToolSelectorControl />
      <GridControl />
      <VideoGridView />
      {!hasSegmentationTool && <SnapControl />}
      <VerticalDivider />
      <UndoRedo />
      <VerticalDivider />
      <RotateControl />
      <ZoomControl />
      <BrightnessControl />
      <ContrastControl />
    </Container>;
}
export default StageControlToolBar;